import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'
import useAdminGuard from './routerGuard/admin'
import useUserInfoGuard from './routerGuard/userInfo'
import useLoginDisplyGuard from './routerGuard/loginDisply'
import { loginRouterGuard } from '@/components/login/routerGuard'

const router = createRouter({
  history: createWebHistory(),
  routes
})

// =========== 以下路由钩子会按照定义顺序执行 ==========
// 拦截admin，如果是/admin则跳回后台
useAdminGuard(router)
// 拦截不同的登录方式，添加缓存
useLoginDisplyGuard(router)
// 登录权限校验
loginRouterGuard(router)
// 用户信息校验
useUserInfoGuard(router)
// ================= export ===================
export default router
